import {
    ServicesPageContainer,
    ServicePageOverlay,
    ServicePageBg,
    ServicePageContent,
    ServicePageTitle,
    ServicePageSecondContent,
    ServicePageSubText,
    ServicesPricingSection,
    ServicePageSubTextBottom
} from "../ServicesElements";
import {
    PricingGrid,
    PricingCard,
    PricingImage,
    PricingBody,
    PricingTitle,
    PricingList,
    PricingFooter,
    PricingFootText,
    PricingButton
} from "../PricingElements";
import {
    DesktopOnly,
    MobileOnly,
    MobileContainer,
    MobileTitle,
    MobileVideo
} from "../../CommonElements";
import { useNavigate } from "react-router-dom";
import silverImage from "../../../images/pricing/Weddingsilver.png";
import goldenImage from "../../../images/pricing/Weddinggold.png";
import diamondImage from "../../../images/pricing/Weddingdiamond.png";

const Wedding = () => {
    const navigate = useNavigate();
    const plans = [
    {
        img: silverImage,
        title: "SILVER",
        price: "£899",
        features: [
            "1-Day Filming and Postproduction",
            "Highlight Video (3-4 minutes)",
            "1x Social Media Reel",
            "Drone Shots",
            "Extra Location",
            "Creative Editing",
            "Professional Contract",
            "Pre-wedding Meeting Idea",
            "Unlimited Downloads"
        ],
        footText: "Best for intimate weddings",
        cta: "Find Out More",
        link: "/summary?type=wedding_silver",
    },
    {
        img: goldenImage,
        title: "GOLD",
        price: "£1,250",
        features: [
            "1-Day Filming and Postproduction",
            "Wedding Reportage (10-15 minutes)",
            "Highlight Video (3-4 minutes)",
            "1x Social Media Reel",
            "Drone Shots",
            "Extra Location",
            "Creative Editing",
            "Professional Contract",
            "Pre-wedding Meeting Idea",
            "Unlimited Downloads",
        ],
        footText: "Most popular choice",
        cta: "Find Out More",
        link: "/summary?type=wedding_gold",
    },
    {
        img: diamondImage,
        title: "DIAMOND",
        price: "£2,650",
        features: [
            "2-Person Film Crew",
            "1-Day Filming and Postproduction",
            "Wedding Reportage (10-15 minutes)",
            "Highlight Video (3-4 minutes)",
            "2x Social Media Reels",
            "Drone Shots",
            "Extra Location",
            "Creative Editing",
            "Professional Contract",
            "1 Round of Revision",
            "Pre-wedding Meeting Idea",
            "Unlimited Downloads"
        ],
        footText: "For the complete story",
        cta: "Find Out More",
        link: "/summary?type=wedding_diamond",
    },
    ];

    return (
        <>
            <DesktopOnly>
                <ServicesPageContainer>
                    <ServicePageBg>
                        <video autoPlay loop muted playsInline className="App-logo">
                        <source src="/videos/wedding_background_video.mp4" type="video/mp4" />
                        </video>
                        <ServicePageOverlay />
                    </ServicePageBg>

                    <ServicePageContent>
                        <ServicePageTitle>
                        Wedding Films that will properly touch your emotions
                        <br />
                        <br />
                        <br />
                        and taking you back to that unforgettable day
                        <br />
                        </ServicePageTitle>
                    </ServicePageContent>
                </ServicesPageContainer>
            </DesktopOnly>

            <MobileOnly>
                <MobileContainer>
                    <MobileTitle mobileFontSize="13px">
                    Wedding Films that will properly touch your emotions<br />
                    and taking you back to that unforgettable day
                    </MobileTitle>
                    <MobileVideo
                    autoPlay
                    muted
                    playsInline
                    loop
                    src="/videos/wedding_background_video.mp4"
                    />
                </MobileContainer>
            </MobileOnly>


        <ServicePageSecondContent>
            <ServicePageSubText>
                We craft heartfelt stories that celebrate your love and capture the magic of your special day.
                <br />
                <br />
                <br />
                From intimate moments and joyful ceremonies to unforgettable receptions, our wedding videos are designed to move, inspire, and be cherished forever.
                <br />
                <br />
                <br />
                Let your love story shine with visuals that create lasting memories.
                <br />
                <br />
                <br />
                Choose the Plan That Fits You Best
            </ServicePageSubText>
        </ServicePageSecondContent>
        <ServicesPricingSection>
            <PricingGrid>
                {plans.map((p) => (
                    <PricingCard key={p.title}>
                    <PricingImage src={p.img} alt={p.title} mobileHeight="420px"/>
                    <PricingBody>
                        <PricingTitle>{p.title} <span style={{fontSize: '18px'}}>{p.price}</span></PricingTitle>
                        <PricingList>
                        {p.features.map((f) => (
                            <li key={f}>{f}</li>
                        ))}
                        </PricingList>
                    </PricingBody>
                    <PricingFooter>
                        <PricingFootText>{p.footText}</PricingFootText>
                        <PricingButton type="button" aria-label={p.cta} onClick={() => navigate(p.link)}>
                        {p.cta}
                        </PricingButton>
                    </PricingFooter>
                    </PricingCard>
                ))}
            </PricingGrid>
        </ServicesPricingSection>
        <ServicePageSecondContent>
            <ServicePageSubText>
                Didn't find the right package? 
                <br />
                <br />
                <PricingButton type="button" aria-label={"👉 Request a Custom Quote"} onClick={() => navigate("/contact")}>
                    👉 Request a Custom Quote
                </PricingButton>
            </ServicePageSubText>
        </ServicePageSecondContent>
        <ServicePageSecondContent>
            <ServicePageSubTextBottom>
                <b>Show</b> your love story at its most beautiful
                <br />
                <br />
                <b>Turn</b> your precious moments into timeless memories
                <br />
                <br />
                <b>Inspire</b> emotions, celebrate connections, and cherish every detail
                <br />
                <br />
            </ServicePageSubTextBottom>
        </ServicePageSecondContent>
        </>
    )
};

export default Wedding;